:host {
  display: block;
  .av-time-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
  }

  av-select{
    @include option-panel;
  }

  .av-time-picker-meridian {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;
    > button {
      border: 0;
      font-size: 0.7em;
      padding: 5px 3px;
      font-weight: bold;
      border-radius: 3px;
      cursor: pointer;
      background-color: transparent;
      font-family: var(--av-font-family);
      color: var(--av-card-color);
    }
    .active {
      background-color: var(--av-color-accent);
      color: var(--av-color-accent-contrast);
    }
  }

  .av-time-picker-input {
    // @include option-panel;
    margin: 0 5px;
    padding: 0;
    av-select{
      padding: 15px 20px 15px;
    }
  }

  // .av-time-picker-dark {
  //   .av-time-picker-meridian button {
  //     color: var(--av-font-color-light);
  //     &.active {
  //       color: white;
  //     }
  //   }
  // }
}
